<template>
  <!-- START : Restricted Item Ribbon -->
  <div class="wc-restricted-ribbon py-1 px-2 font-size-xs rounded">
    {{ textContent }}
  </div>
  <!-- END : Restricted Item Ribbon -->
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  name: 'WCPromoRibbon',
  computed: {
    textContent() {
      if (this.item.hasTimeRestrictions) {
        return `${this.$t('itemProhibited')}`;
      }
      if (this.item.cashierApprovalRequired) {
        return `${this.$t('cashierApproval')}`;
      }
      if (this.item.hasAgeRestriction) {
        return `${this.$t('idRequired')}`;
      }
      if (this.item.weightProfile) {
        return `${this.$t('weightedItem')}`;
      }

      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';
.wc-restricted-ribbon {
  display: inline-block;
  background-color: gray;
  color: white;
}
</style>
